import axios from 'axios'
import { Notification, MessageBox, Message, Loading } from 'element-ui'
import { getToken, removeToken } from '@/utils/auth'
import { tansParams, blobValidate } from '@/utils/ruoyi'
import errorCode from '@/utils/errorCode'
import router from '@/router'
import store from '@/store'
import { saveAs } from 'file-saver'
// 是否显示重新登录
export let isRelogin = { show: false }

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 30000,
})
// request拦截器
service.interceptors.request.use(
  (config) => {
    // 携带token
    if (getToken() && config.headers) {
      config.headers['Authorization'] = `Bearer ${getToken()}`
    }
    return config
  },
  (err) => Promise.reject(err)
)
// 响应拦截器
service.interceptors.response.use(
  (res) => {
    // 默认状态
    const code = res.data.code || 200
    // 获取错误信息
    const msg =
      errorCode[code] ||
      res.data.msg ||
      res.data.message ||
      errorCode['default']
    // 二进制数据处理
    if (
      res.request.responseType === 'blob' ||
      res.request.responseType === 'arraybuffer'
    ) {
      return res.data
    }
    // 401处理
    if (code === 401) {
      if (!isRelogin.show) {
        isRelogin.show = true
        Message.warning('登录状态已过期请重新登录')
        removeToken()
        router.push('/login')
      }
      return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    } else if (code === 500) {
      Message({ message: '错误' + msg, type: 'error' })
      return Promise.reject(new Error(msg))
    } else if (code === 601) {
      Message({ message: msg, type: 'warning' })
      return Promise.reject('error')
    } else if (code !== 200) {
      Notification.error({ title: msg })
      return Promise.reject('error')
    } else {
      return res.data
    }
  },
  // 错误反馈
  (error) => {
    let { message } = error
    if (message == 'Network Error') {
      message = '服务连接异常'
    } else if (message.includes('timeout')) {
      message = '系统请求超时'
    } else if (message.includes('Request failed with status code')) {
      message = '系统服务' + message.substr(message.length - 3) + '异常'
    }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000,
    })
    return Promise.reject(error)
  }
)
let downloadLoadingInstance
// 导出文件流方法
export function download(url, params, filename, config) {
  downloadLoadingInstance = Loading.service({
    text: '正在下载数据，请稍候',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)',
  })
  return service
    .post(url, params, {
      transformRequest: [
        (params) => {
          return tansParams(params)
        },
      ],
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: 'blob',
      ...config,
    })
    .then(async (data) => {
      const isBlob = blobValidate(data)
      if (isBlob) {
        const blob = new Blob([data])
        saveAs(blob, filename)
      } else {
        const resText = await data.text()
        const rspObj = JSON.parse(resText)
        const errMsg =
          errorCode[rspObj.code] || rspObj.msg || errorCode['default']
        Message.error(errMsg)
      }
      downloadLoadingInstance.close()
    })
    .catch((r) => {
      console.error(r)
      Message.error('下载文件出现错误，请联系管理员！')
      downloadLoadingInstance.close()
    })
}
export default service
